import React, { Component } from "react"
import Svg from "../_svgs/svg"
import * as endpoints from "../../api/endpoints"
import { getQueryStringValue, setQueryStringValue, setQueryStringWithoutPageReload } from "../../api/queryStringHelper"
import { isMobile } from "react-device-detect"
import smoothscroll from "smoothscroll-polyfill"

export default class AirlineList extends Component {
  constructor(props) {
    super(props)

    const querystring = getQueryStringValue("query") ?? ""
    const numberOfAirlines = isMobile ? props.numberOfAirlinesMobile : props.numberOfAirlines
    const airlines = querystring.length < 2 ? props.zeroStateAirlines : props.airlines
    const shownAirlines = airlines.slice(0, numberOfAirlines)

    smoothscroll.polyfill()

    this.state = {
      zeroStateAirlines: props.zeroStateAirlines,
      airlines: airlines,
      query: querystring,
      airlinesShown: numberOfAirlines,
      shownAirlines: shownAirlines,
    }
  }

  componentDidUpdate() {
    // set zero state airlines if query length is under 2
    if (this.state.query < 2 && this.state.airlines !== this.state.zeroStateAirlines) {
      const numberOfAirlines = isMobile ? this.props.numberOfAirlinesMobile : this.props.numberOfAirlines
      const shownAirlines = this.state.zeroStateAirlines.slice(0, numberOfAirlines)
      this.setState({ airlines: this.state.zeroStateAirlines, shownAirlines: shownAirlines, airlinesShown: numberOfAirlines })
    }
  }

  handleInput = (event) => {
    const name = event.target.name
    const value = event.target.value
    this.setState({ [name]: value })
    this.search(value, this.props.language)
    if (value) setQueryStringValue(name, value)
    else {
      // delete query param if value is null
      const params = new URLSearchParams(window.location.search)
      params.delete(name)
      setQueryStringWithoutPageReload(`?${params.toString()}`)
    }
  }

  search = async (query, language) => {
    // dont search
    if (query.length < 2) return

    // do airline search
    const userQuery = query
    const data = { query: userQuery ?? "", language: language }
    const response = await endpoints.getAirlines(data)
    let airlines = []
    if (response && response.data) {
      airlines = response.data
    }
    const numberOfAirlines = isMobile ? this.props.numberOfAirlinesMobile : this.props.numberOfAirlines
    const shownAirlines = airlines.slice(0, numberOfAirlines)
    this.setState({ airlines: airlines, shownAirlines: shownAirlines, airlinesShown: numberOfAirlines })
  }

  handleMoreClick = (increase) => {
    const airlines = this.state.airlines ?? []
    const newAmount = this.state.airlinesShown + increase
    const shownAirlines = airlines.slice(0, newAmount)
    this.setState({ airlinesShown: newAmount, shownAirlines: shownAirlines }, () => {
      var elements = document.getElementsByClassName("next-airlines-wrapper")
      if (elements.length > 0) {
        const element = elements[0]
        element.classList.remove("open")
        element.classList.add("opening")
        setTimeout(function () {
          element.classList.remove("opening")
          element.classList.add("open")
        }, 500)
      }
    })
  }

  handleHideClick = () => {
    const airlines = this.state.airlines ?? []
    const numberOfAirlines = isMobile ? this.props.numberOfAirlinesMobile : this.props.numberOfAirlines
    const shownAirlines = airlines.slice(0, numberOfAirlines)
    this.setState({ airlinesShown: numberOfAirlines, shownAirlines: shownAirlines }, () => {
      const searchField = document.getElementById("airline-search-field")
      if (searchField) {
        this.scrollIntoView(searchField)
      }
    })
  }

  scrollIntoView = (element) => {
    const siteHeader = document.getElementsByClassName("site-header")[0]
    const headerOffset = siteHeader.clientHeight + 20
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })
  }

  render() {
    return (
      <div className="airline-list">
        <div className="airline-list-inner">
          <div className="form">
            <div className="form__section">
              <div className="form__section__inner">
                <div id="airline-search-field" className="form__field form__field--text form__field--text-search form__field--text--no-label">
                  <button>
                    <Svg iconName="search" />
                  </button>
                  <span className="form__valid"></span>
                  <input
                    className="form__item"
                    name="query"
                    type="text"
                    placeholder={this.props.searchFieldLabel || "Søg på flyselskab"}
                    value={this.state.query}
                    onChange={(e) => this.handleInput(e)}
                    autoComplete="off"
                  />
                </div>
              </div>
            </div>
          </div>
          {this.state.airlines && this.state.airlines.length > 0 ? (
            <React.Fragment>
              <Airlines
                airlines={this.state.shownAirlines}
                allAirlines={this.state.airlines}
                increaseAmount={isMobile ? this.props.numberOfAirlinesIncrementMobile : this.props.numberOfAirlinesIncrement}
                initialAmount={isMobile ? this.props.numberOfAirlinesMobile : this.props.numberOfAirlines}
                amountShown={this.state.airlinesShown}
              />
              <div
                className={`buttoncontainer ${this.state.airlines && this.state.airlines.length > this.props.numberOfAirlines ? "has-button" : ""}`}
              >
                {this.state.airlines && this.state.airlines.length > this.props.numberOfAirlines ? (
                  <a
                    className="button button--expander"
                    onClick={() =>
                      this.state.airlinesShown >= this.state.airlines.length
                        ? this.handleHideClick()
                        : this.handleMoreClick(isMobile ? this.props.numberOfAirlinesIncrementMobile : this.props.numberOfAirlinesIncrement)
                    }
                  >
                    <span className="text">
                      {this.state.airlinesShown >= this.state.airlines.length
                        ? this.props.showLessAirlinesText || "Vis færre"
                        : this.props.showMoreAirlinesText || "Vis flere"}
                    </span>
                  </a>
                ) : (
                  ""
                )}
              </div>
            </React.Fragment>
          ) : (
            <div className="airline-list__no-results">
              <div className="section-header section-header--small">
                <p>{this.props.noResultsText.replace("{input}", this.state.query)}</p>
                <div>
                  <h2>{this.props.noResultsHeader}</h2>
                  <p>{this.props.noResultsSubHeader}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

class Airlines extends Component {
  render() {
    if (this.props.airlines && this.props.airlines.length > 0) {
      const airlines = this.props.airlines.map((airline, index) => {
        return (
          <div className="airline-list-item" key={index}>
            <a
              className="button airlinetable"
              href={airline.PageUrl_s}
              onTouchStart={(e) => e.currentTarget.classList.add("touched")}
              onTouchEnd={(e) => e.currentTarget.classList.remove("touched")}
            >
              <div className="airlinelogo">
                <div className="logocontainer">
                  <img src={airline.AirlineLogo_s} alt={airline.AirlineName_s} />
                </div>
              </div>
              <div className="airlineinfo">
                <div className="infocontainer">
                  <div className="airlinename">{isMobile && airline.AirlineNameMobile_s ? airline.AirlineNameMobile_s : airline.AirlineName_s}</div>
                  <div className="terminal">{airline.TerminalCheckIn_s}</div>
                </div>
              </div>
            </a>
          </div>
        )
      })

      let newAirlines = ""
      let oldAirlines = ""
      let increaseAmount = this.props.increaseAmount
      const sizeDiff = this.props.allAirlines.length - this.props.amountShown
      if (sizeDiff < 0) {
        increaseAmount = this.props.increaseAmount - Math.abs(sizeDiff)
      }
      const index = airlines.length - increaseAmount
      oldAirlines = airlines.slice(0, index)
      newAirlines = airlines.slice(index)

      return (
        <React.Fragment>
          {oldAirlines}
          <div className={airlines.length <= this.props.initialAmount ? "" : "next-airlines-wrapper"}>{newAirlines}</div>
        </React.Fragment>
      )
    }
    return ""
  }
}
